module.exports = __webpack_public_path__ + "img/SMRT.b90989e5.svg";